import { Row, Col, Modal, Button, Input, Form, notification, message } from "antd";
import { useEffect, useState } from "react";
import axios from "axios";
import config from "../../utils/config.js";
import { DeleteOutlined } from "@ant-design/icons";
import endpoints from "../../utils/endpoints.js";

export default function Delete({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);
  const [form] = Form.useForm();

  function submit() {
    setIsButtonLoading(true);
    axios
      .post(endpoints.committee.delete, {
        data: { id: data.id },
      })
      .then((res) => {
        closeModal();
        message.success("Membro da comissão foi apagado com sucesso!");
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        message.error("Algo de errado aconteceu! Tente novamente mais tarde.");
      });
  }

  function closeModal() {
    close();
    setIsButtonLoading(false);
    form.resetFields();
  }

  return (
    <Modal
      className="modal-antd-committee"
      title={`Apagar membro`}
      open={open}
      onCancel={closeModal}
      footer={[
        <Button danger icon={<DeleteOutlined />} size="large" type="primary" onClick={submit} loading={isButtonLoading} disabled={isButtonLoading}>
          Apagar
        </Button>,
        <Button size="large" onClicdk={closeModal}>
          Cancelar
        </Button>,
      ]}
    >
      <div className="p-4">
        <p>Tem a certeza que quer apagar o membro:</p>
        <p className="font-bold text-lg mt-2">{data.name}</p>
      </div>
    </Modal>
  );
}
